import { CompanyEmployeesConfigType } from '../types/company-config'

export const CompanyEmployeesConfig: CompanyEmployeesConfigType[] = [
  {
    min: '1',
    max: '5',
  },
  {
    min: '6',
    max: '10',
  },
  {
    min: '11',
    max: '50',
  },
  {
    min: '50+',
  },
]
